module.exports = __webpack_public_path__ + "static/media/edu_classroom.3a1449b9.webp";